import { jsxs as v, jsx as x } from "react/jsx-runtime";
import C, { useState as m, useMemo as _, useEffect as s } from "react";
import { Combobox as k, ComboboxSearchInput as B } from "@vp/swan";
import { useSearchContext as L } from "./help-center-articles-search3.js";
import { getSearchSelectedItemFromQueryItems as $, getSearchSelectedItemPosition as H } from "./help-center-articles-search9.js";
import { HCSComboboxPopover as j } from "./help-center-articles-search10.js";
import { useQuerySuggestions as M } from "./help-center-articles-search11.js";
import N from "./help-center-articles-search12.js";
import { getSearchBarEngagedTypedEventData as V, getSearchBarEngagedEventData as A } from "./help-center-articles-search13.js";
import { getQuerySubmittedEventData as K } from "./help-center-articles-search14.js";
import { getSearchResultClickedTrackingData as O } from "./help-center-articles-search15.js";
/* empty css                              */
import { getDestinationUrl as W } from "./help-center-articles-search17.js";
import z from "./help-center-articles-search18.js";
const le = (h) => {
  const { variation: d = "header", onQueryResultsChange: f } = h, g = C.useRef(null), p = C.useRef(null), [R, T] = m(!1), [F, q] = m(!1), [o, i] = m(""), { resultsPageUrl: a, locale: S, environment: b, translate: c, logger: G, applicationName: E } = L(), [n] = z(), { queryResults: r } = M({
    environment: b,
    locale: S,
    applicationName: E,
    path: typeof window < "u" ? window?.location?.pathname : new URL(a)?.pathname,
    track: n
  });
  function u(e) {
    r.setFilterText(e);
  }
  const l = _(() => N(
    (e) => {
      u(e);
    },
    200,
    { maxWait: 1e3 }
  ), []);
  s(() => () => {
    l.cancel();
  }, [l]);
  const w = (e) => !e || r && r.filterText.includes(e);
  s(() => {
    const e = document?.location.search && new URLSearchParams(document.location.search), t = e ? e?.has("query") && e?.get("query") : "";
    t && (i(t), u(t));
  }, []), s(() => {
    f?.(r.items);
  }, [r.items, f]);
  function U(e) {
    R || (n(V(a)), T(!0)), i(e), w(e) ? u(e) : l(e);
  }
  function D(e) {
    e.preventDefault(), n(K(o, document.location.pathname)), document.location.href = `${a}${encodeURIComponent(o)}`;
  }
  function I(e) {
    const t = $(r.items, e);
    if (!t)
      return;
    const y = W({ landingUrl: t?.landingUrl, query: o });
    n(
      O({
        searchSelectedItem: t,
        query: o,
        location: document?.location?.pathname,
        resultPosition: H(r.items, e),
        resultDestination: y,
        locale: S,
        environment: b,
        resultsLength: r.items.flatMap((Q) => Q.items).length
      })
    ), g.current?.blur(), p.current?.blur(), document.location.href = y;
  }
  const P = () => {
    F || (n(A(a)), q(!0));
  };
  return s(() => {
    const e = document?.location.search && new URLSearchParams(document.location.search), t = e ? e?.has("query") && e?.get("query") : "";
    t && i(t);
  }, []), /* @__PURE__ */ v(
    k,
    {
      "aria-label": c("searcher.aria_label"),
      maxHeight: 1200,
      menuTrigger: "focus",
      inputValue: o,
      disableAutoFilter: !0,
      selectedKey: "",
      ref: g,
      onInputChange: U,
      onSelectionChange: (e) => {
        e && I(e);
      },
      allowsCustomValue: !0,
      ...h.comboboxOverrides,
      className: "help-center-articles-combobox",
      children: [
        /* @__PURE__ */ x(
          B,
          {
            ref: p,
            placeholder: c(`searcher.placeholder_${d}`),
            accessibleTextForSearchButton: c(`searcher.placeholder_${d}`),
            accessibleTextForClearButton: c("searcher.clear"),
            onFocusCapture: P,
            onSearchSubmit: D,
            "data-testid": "query-suggestions",
            style: { width: "100%" }
          }
        ),
        /* @__PURE__ */ x(j, { queryResults: r })
      ]
    }
  );
};
export {
  le as default
};
//# sourceMappingURL=help-center-articles-search4.js.map
